import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoachSettingsBiographyState {
	isSaving: boolean;
}

@Injectable()
export class CoachSettingsBiographyStore extends Store<CoachSettingsBiographyState> {
	constructor() {
		super({}, { name: `ui-coach-settings-biography-${guid()}` });
	}
}
